import Immutable from 'immutable';
import type moment from 'moment';

import User from 'sharedreact/data/User';
import ClassFactory from 'sharedreact/utils/ClassFactory';
import { translate } from 'sharedreact/utils/LanguageSupport';

import ToDoParameter from 'workspaces/common/data/ToDoParameter';

const Content: {
  id: string,
  type: string,
  typeId: string,
  state: number,
  jobId: string,
  jobName: string,
  application: string,
  sender: User | null,
  receiver: User | null,
  dueDate: moment.Moment | null,
  reminderDate: moment.Moment | null,
  creationDate: moment.Moment | null,
  finishedDate: moment.Moment | null,
  body: string,
  bodyArgs: Immutable.List<string>,
  subject: string,
  subjectArgs: Immutable.List<string>,
  outputs: Immutable.List<Immutable.Map<string, string>> | null,
  autoReleaseDate: moment.Moment | null,
  releaseOutput: string,
  files: Immutable.List<string> | null,
  wfId: string,
  linkedProduct: string | null,
  linkedSide: string | null,
  linkedProductionJob: string | null,
  todoParameters: Immutable.List<ToDoParameter> | null,
  location: string
} = {
  id: '',
  type: '',
  typeId: '',
  state: 0,
  jobId: '',
  jobName: '',
  application: '',
  sender: null,
  receiver: null,
  dueDate: null,
  reminderDate: null,
  creationDate: null,
  finishedDate: null,
  body: '',
  bodyArgs: Immutable.List(),
  subject: '',
  subjectArgs: Immutable.List(),
  outputs: null,
  autoReleaseDate: null,
  releaseOutput: '',
  files: null,
  wfId: '',
  linkedProduct: '',
  linkedSide: '',
  linkedProductionJob: '',
  todoParameters: null,
  location: ''
};

class ToDo extends Immutable.Record(Content) {
  static fromJS (json: object): ToDo {
    return ClassFactory.createFromJson(json, ToDo);
  }

  static get State () {
    return {
      PENDING: 0,
      INPROGRESS: 1,
      DONE: 2
    };
  }

  static getStringIdForState (state: number): string | null {
    switch (state) {
      case 0:
        return 'common.todos.state.pending';
      case 1:
        return 'common.todos.state.inprogress';
      case 3:
      case 2:
        return 'common.todos.state.done';
      default:
        return null;
    }
  }

  static getStringForState (state: number): string {
    const stateStringID: string | null = ToDo.getStringIdForState(state);

    if (stateStringID != null) {
      return translate(stateStringID);
    }

    return '';
  }

  get stateString (): string {
    return ToDo.getStringForState(this.state);
  }

  get name (): string {
    return this.id;
  }

  static createTemp (): ToDo {
    return new ToDo();
  }
}

export default ToDo;
